import is from './is';
import en from './en';

export default {
  is, en,
};
